import React from 'react';

import DiscountBlock from '../DiscountBlock';
import PriceBlock from '../PriceBlock';

const getCreditCardInput = (props, plan, parcels, selectMethodPayment, i) => (
  <li key={props.paymentMethods[i].id} data-cy="method-credit-card">
    <button
      type="button"
      className={`${props.paymentMethods[i].class}  opcao`}
      onClick={() => selectMethodPayment(i, 'credit-card', props)}
    >
      <div className='mobile-payment-card'>
        <div className="icon-payment-mobile">
          <img src={`/assets/images/pagamento/${props.paymentMethods[i].img}.svg`} alt="pagamento" />
        </div>
        <div className="infos-payment-mobile">
          <h4 className="name-payment-mobile">{props.paymentMethods[i].name}</h4>
          <div className="text-payment-mobile">
            <div className="desc-info">American Express, Visa, Mastercard Elo, Diners Club Internacional</div>

            <DiscountBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="credit-card"
            />
            <PriceBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="credit-card"
            />

            <div className="small-payment">Pague em até {parcels ? parcels.parcels : '12'}x sem Juros</div>
          </div>
        </div>
      </div>
      <div className="advancer-payment-mobile">
        <div></div>
      </div>
    </button>
  </li>
);

export default getCreditCardInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/inputs/getCreditCardInput.jsx